import React from 'react';

export default function Personal(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M12 3.344h10.656c.375 0 .688.135.938.406.27.25.406.552.406.906v6.688h-1.344V4.656H12v24h10.656v-8H24v8c0 .375-.135.698-.406.969-.25.25-.563.375-.938.375H12a1.38 1.38 0 01-.969-.375 1.38 1.38 0 01-.375-.969v-24c0-.354.125-.656.375-.906.271-.27.594-.406.969-.406zm20.656 12H28v-4.688a.562.562 0 00-.219-.437.562.562 0 00-.437-.219.688.688 0 00-.5.219.6.6 0 00-.188.437v4.688H22a.636.636 0 00-.469.187.636.636 0 00-.187.469.636.636 0 00.656.656h4.656v4.688c0 .166.063.323.188.468a.746.746 0 00.5.188.6.6 0 00.437-.188c.146-.145.219-.302.219-.468v-4.688h4.656a.636.636 0 00.469-.187.592.592 0 00.219-.469.592.592 0 00-.219-.469.636.636 0 00-.469-.187zM1.344 9.188l8-3.75v-1.47l-8.563 4a1.227 1.227 0 00-.687.75c-.125.355-.115.699.031 1.032L9.344 29.5v-3.156l-8-17.157z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
